import { ContentModal } from 'features/modals';
import { Outlet } from 'react-router-dom';
import { useLocation, useNavigate } from 'react-router-dom';
import { useBreakpointValue, Box } from '@telescope/cassini-ui';
import { AdUnit, AdUnitSize } from 'components';
import { useWidget } from '@telescope/cassini-hooks';
import { Campaign } from 'types';

export const AuthLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as {
    backgroundLocation?: Location;
  };

  const { data: widgetData } = useWidget({ select: (data: Campaign) => data.widget });
  const { ads } = widgetData!;

  const adSize: AdUnitSize = useBreakpointValue({ base: 'mobileLeaderboard', md: 'leaderboard' })!;
  const authAd = ads.auth[adSize];

  return (
    <ContentModal isOpen size={{ base: 'full', lg: '5xl' }} 
      bodyProps={{ minH: '90vh', display: 'flex', flexDirection: 'column' }} 
      onClose={() => navigate(state.backgroundLocation!, { replace: true })}>
      <Box w="100%" flexGrow={2}>
        <Outlet />
      </Box>
      <AdUnit size={adSize} alignSelf="center" mx="auto" mt={[5, 8]} mb={0} {...authAd}></AdUnit>
    </ContentModal>
  )
}